<template>
<div>
    <div style="display: flex">
        <div class="col-md-12">
            <div class="area custom-area">
                <div class="row">
                        <div class="form-group col-4">
                            <CAreas
                                v-on:valorParaElPadre="cambioDeArea" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="'filtroDeBusqueda_Area'" 
                                :parametros="BusquedaForm.parametros_Area" 
                                :valorDefinido="BusquedaForm.parametros_Area.areaId" 
                                >
                            </CAreas>
                        </div>
                        <div class="form-group col-3">
                            <div id="BotonBusqueda_div" class="text-left">
                                <button class="btn btn-sm btn-custom"  @click='ObtenSolicitudes(true)'>Obtener Solicitudes</button>
                            </div>
                        </div>
                </div>
            
        
                <div id="datos_div" v-if="Solicitudes.length>0">
                    <div>
                        <h6  class="label-black">Listado de Solicitudes {{this.AreaEtiqueta}}, total: {{this.Solicitudes.length}}</h6>
                    </div>
                    <div id="solicitudes_table" class="table-responsive">
                        <table class="table table-striped table-light table-hover table-sm">
                            <thead class="thead-custom">
                                <tr>
                                    <th>#</th>
                                    <th>Fecha Solicitud</th>
                                    <th>Tipo Documento</th>
                                    <th>Consecutivo</th>
                                    <th>Estatus</th>
                                    <th>Sede de Archivo</th>
                                    <!-- <th></th> -->
                                    <th></th>
                                    <th class="text-center"> 
                                        Autorizar : 
                                        <input id="checkTotodos" type="checkbox" v-on:click="SelectAll($event)" v-model="SeleccionarTodos" class="vertical-align-bottom" />
                                    </th>
                                    <th class="text-center">Cancelar</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody class="text-dark">
                                <tr v-if="Solicitudes.length <= 0">
                                    <td colspan="12" class="text-center">No hay registro de Solicitudes en área seleccionada</td>
                                </tr>
                                <tr v-else v-for="Lista in Solicitudes" :key="Lista.SolicitudDocumentoId">
                                    <td>{{Lista.SolicitudDocumentoId}}</td>
                                    <td v-html="obtenFechaConFormato(Lista.FechaRegistro)"></td>
                                    <td><h6><span class="badge badge-primary">{{Lista.InventarioDocumentos.TipoDocumento.Nombre}}</span></h6></td>
                                    <td >{{Lista.InventarioDocumentos.Consecutivo}}/{{Lista.InventarioDocumentos.Anio}}</td>
                                    <td>{{Lista.TipoEstatusSolicitud.Nombre}}</td>
                                    <td>{{Lista.InventarioDocumentos.SedeArchivo.Nombre}}</td>
                                    <!-- <td>
                                        <i class="fas fa-eye" @click='DetallesVolumen(Lista)' title ="Ver Detalles de Solicitud"></i>
                                    </td> -->
                                    <td class="text-center" v-if="Lista.ObservacionesArchivo!=null">
                                        <i class="fas fa-edit" @click='AgregaComentario(Lista)' title ="Edita Detalles/Contenido"></i>
                                    </td>
                                    <td class="text-center" v-else>
                                        <i class="fas fa-plus" @click='AgregaComentario(Lista)' title ="Agregar Detalles/Contenido"></i>
                                    </td>

                                    <td class="category_enabled text-center" >
                                        <input v-model="Autorizadas" v-bind:value="Lista.SolicitudDocumentoId" type="checkbox" />
                                    </td>
                                    <td class="category_enabled text-center" >
                                        <input v-model="Canceladas" v-bind:value="Lista.SolicitudDocumentoId" type="checkbox" />
                                    </td>
                                    <td>
                                        <i class="fas fa-print" @click='ImprimirValeSeleccionado(Lista)' title ="Imprimir Vale"></i>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <label class="label-black">Solicitudes seleccionadas para Prestamo :  {{this.Autorizadas.length}}</label>
                        </div>
                        <div>
                            <label class="label-black">Solicitudes seleccionadas para Cancelación :  {{this.Canceladas.length}}</label>
                        </div>
                        
                        
                    </div>
                </div>
                <div class="row" v-if="Solicitudes.length>0">
                        <div class="form-group col-3 text-left"></div>
                        <div class="form-group col-3 text-left">
                            <button class="btn btn-sm btn-info" @click='ImprimirVales(Solicitudes)' >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Imprimir Vales&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
                        </div>
                        <div class="form-group col-3 text-center">
                            <button class="btn btn-sm btn-success" @click='PrestamoSolicitud(CanceladasReporte)' >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Autorizar Solicitudes&nbsp;&nbsp;&nbsp;&nbsp;</button>
                        </div>
                        <div class="form-group col-3 text-right">
                            <button class="btn btn-sm btn-danger" @click='CancelarSolicitud()' >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cancelar Solicitudes&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
                        </div>
                    </div>
            </div>
        </div>
    </div>
    
    <div v-if="this.Detalles==true" id="DatosSolicitud">
        <Modal :Solicitudes="this.DatosEnvio" @dialogo='EstatusModal($event)'></Modal>
    </div>
    <div v-if="this.Arch_Observaciones==true" id="observacionesArchivo">
        <ObsArchivo :Id="this.idModal" :Detalle="this.ObsModal" @dialogo='EstatusObservaciones($event)'></ObsArchivo>
    </div>

</div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'
import ModalDetalles from '@/components/ArchivoJudicial/Comun/DetalleSolicitud.vue'
import LogoPJE from '@/../src/assets/Logotipo_Positivo_Vertical-recibo.png'
import Contenido from '@/components/ArchivoJudicial/Comun/ComentarioSolicitud.vue'

export default {
    components:{
      CAreas : catalogos.ArchivoJudicial.C001Areas,
      Modal: ModalDetalles,
      ObsArchivo: Contenido
    },
    props: {
        SolicitudApi: ""
    },
    data(){
        return{
            enumeraciones,
            Detalles: false,
            BusquedaForm: {
                parametros_Area: {
                    areaId: -1,
                    Nombre: "",
                    conMaterias: true,
                    Materias: [ { MateriaId: 1, Activo: true },{ MateriaId: 2, Activo: true }, { MateriaId: 3, Activo: true }, { MateriaId: 4, Activo: true }, { MateriaId: 5, Activo: true } , { MateriaId: 6, Activo: true }, { MateriaId: 9, Activo: true }, { MateriaId: 13, Activo: true } ], 
                    conOrdenamientoPorSistema:true
                }
            },
            Solicitudes: [],
            DatosEnvio: {},
            UsuarioArchivo: {},
            AreaEtiqueta:"",
            Autorizadas: [],
            Canceladas:[],
            Arch_Observaciones: false,
            idModal:0,
            ObsModal:"",
            SeleccionarTodos: false,
            TodosParaVales : [],
            SecretarioAcuerdos: "",
            PuestoFirma: "",
            FechaDeAcceso: "",
            CanceladasReporte : []
        }
    },
    methods: {
        obtenFechaConFormato: function(fechaRegistro) {
            return moment(fechaRegistro).format("DD-MM-YYYY");
        },
        cambioDeArea(datos){
           
            this.BusquedaForm.parametros_Area.areaId = parseInt(datos[0].target.value);
            this.BusquedaForm.parametros_Area.Nombre = datos[0].target.selectedOptions[0].text
            this.Autorizadas = [];
            this.Canceladas=[];
            this.SeleccionarTodos = false;
        },
        ObtenSolicitudes(estado){
            //Obtiene lista de Solicitudes por Area Seleccionada
            this.Canceladas= [];
            this.Autorizadas = []
            this.Solicitudes=[];
            if (estado==true)
            {
                this.CanceladasReporte = [];
            }
            if(this.ValidaDatos())
            {
            var peticion = {
                "AreaId" : this.BusquedaForm.parametros_Area.areaId
            };
            this.AreaEtiqueta = this.BusquedaForm.parametros_Area.Nombre;
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + this.SolicitudApi, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {
                    this.Solicitudes = respuesta.data.GetSolicitudes;
                    this.Solicitudes.sort(this.sortAnioConsecutivo);
                    // if( respuesta.data.SecretariosAcuerdos!= null && respuesta.data.SecretariosAcuerdos.length>0)
                    // {
                    //     this.SecretarioAcuerdo = respuesta.data.SecretariosAcuerdos[0];
                    // }
                    
                    // if( respuesta.data.SecretarioAcuerdos!= null)
                    // {
                        this.SecretarioAcuerdos = respuesta.data.SecretarioAcuerdos;
                        this.PuestoFirma = respuesta.data.PuestoFirma
                    //}
                    
                    this.$nextTick(()=> { PaginarTabla('solicitudes_table', 15)});
                    //this.UsuarioArchivo =  respuesta.data.UsuarioArchivo;
                    if(this.Solicitudes.length  <= 0)
                    {
                        
                        comun.mensajeDeAlerta("No hay solicitudes por verificar en " + this.AreaEtiqueta, null, null);
                    }

                }
                comun.SeEstaCargandoInformacion(false);

                })
                .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);

            })
            }
        },
        DetallesVolumen: function(datos){

            this.DatosEnvio =  datos;
            this.Detalles = true;
        },
        PrestamoSolicitud: function(datos){
            const canceladasReporte = datos;
            let SolicitudesAutorizadas =  this.SeleccionSolicitudes();
            if(SolicitudesAutorizadas.length > 0)
            {
                var usr = this.UsuarioArchivo.IdUsuario;
                var areaArchivo = this.UsuarioArchivo.AreaAsignado.AreaId;

                var MovimientosDocumentos =[];
                
                $.each(SolicitudesAutorizadas, function(indice, solicitud)
                {
                    
                    $.each(solicitud.VolumenesEnSolicitud, function (indice, volsId){
                            
                            MovimientosDocumentos.push({
                                VolumenId : volsId.VolumenId,
                                IncidenteId: null,
                                TerceriaId: null,
                                FechaMovimiento : moment().format('YYYY-MM-DD HH:MM:SS'),
                                TiposMovimientos: {"TipoMovimientoId": 2},
                                UsuarioQuienPresta: {"IdUsuario" : usr},
                                UsuarioQuienRecibe: {"IdUsuario" : solicitud.Juzgado.UsuarioIdQuienSolicita.IdUsuario},
                                AreaQuePresta : {"AreaId" : areaArchivo},
                                AreaQueRecibe : {"AreaId" : solicitud.Juzgado.AreaIdQueSolicita.AreaId},
                                SolicitudDocumentoId: solicitud.SolicitudDocumentoId,
                                Observaciones: "Movimiento de Documento en autorización de prestamo con solicitud No. " + solicitud.SolicitudDocumentoId
                            });
                        
                    });
                    
                    $.each(solicitud.IncidentesEnSolicitud, function (indice, volsId){

                            MovimientosDocumentos.push({
                                VolumenId : null,
                                IncidenteId: volsId.IncidenteId,
                                TerceriaId: null,
                                FechaMovimiento : moment().format('YYYY-MM-DD HH:MM:SS'),
                                TiposMovimientos: {"TipoMovimientoId": 2},
                                UsuarioQuienPresta: {"IdUsuario" : usr},
                                UsuarioQuienRecibe: {"IdUsuario" : solicitud.Juzgado.UsuarioIdQuienSolicita.IdUsuario},
                                AreaQuePresta : {"AreaId" : areaArchivo},
                                AreaQueRecibe : {"AreaId" : solicitud.Juzgado.AreaIdQueSolicita.AreaId},
                                SolicitudDocumentoId: solicitud.SolicitudDocumentoId,
                                Observaciones: "Movimiento de Documento en autorización de prestamo con solicitud No. " + solicitud.SolicitudDocumentoId
                            });
                            
                    });
                    $.each(solicitud.TerceriasEnSolicitud, function (indice, volsId){

                            MovimientosDocumentos.push({
                                VolumenId : null,
                                IncidenteId: null,
                                TerceriaId: volsId.TerceriaId,
                                FechaMovimiento : moment().format('YYYY-MM-DD HH:MM:SS'),
                                TiposMovimientos: {"TipoMovimientoId": 2},
                                UsuarioQuienPresta: {"IdUsuario" : usr},
                                UsuarioQuienRecibe: {"IdUsuario" : solicitud.Juzgado.UsuarioIdQuienSolicita.IdUsuario},
                                AreaQuePresta : {"AreaId" : areaArchivo},
                                AreaQueRecibe : {"AreaId" : solicitud.Juzgado.AreaIdQueSolicita.AreaId},
                                SolicitudDocumentoId: solicitud.SolicitudDocumentoId,
                                Observaciones: "Movimiento de Documento en autorización de prestamo con solicitud No. " + solicitud.SolicitudDocumentoId
                            });
                            
                    });
                    

                });

                let peticion = {
                    SolicitudesAutorizadas,
                    MovimientosDocumentos,
                    };
                    
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.CambiaEstadoSolicitud, peticion, comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                if(respuesta.data.SiHayError)
                        {
                            console.log(respuesta);
                            comun.SeEstaCargandoInformacion(false);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        }
                    else
                        {
                            
                            if(datos.length>0)
                            {
                                datos.forEach((element)=>{
                                    SolicitudesAutorizadas.push(element)
                                })
                            };
                            
                            bootbox.confirm({
                                title: "Mensaje del sistema",
                                message: "Se ha autorizado la(s) Solicitud(es). ¿Desea imprimir formato para entrega de documento?",
                                buttons: {
                                cancel: {
                                    label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                                },
                                confirm: {
                                    label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                                }
                            },
                            callback: (respuesta)=> {
                                if (respuesta) {
                                    var usuario = this.UsuarioArchivo;
                                    this.GenerarPrint(SolicitudesAutorizadas, usuario);
                                }
                                this.ObtenSolicitudes(true);
                                }
                            });
                        }
                    comun.SeEstaCargandoInformacion(false);
                }).catch(excepcion => {
                    console.log(excepcion);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                });
            }
            else
            {
                comun.mensajeDeAlerta("Seleccione Solicitudes para Autorizar prestamo", null, null);
            }
        },
        CancelarSolicitud(){
            let _this =this;
            var usr = this.UsuarioArchivo.IdUsuario;
            var areaArchivo = this.UsuarioArchivo.AreaAsignado.AreaId;
            let SolicitudesAutorizadas = this.SeleccionCanceladas();
            var MovimientosDocumentos = [];
            
            $.each(SolicitudesAutorizadas, function(indice, solicitud)
                {
                    
                    $.each(solicitud.VolumenesEnSolicitud, function (indice, volsId){
                            
                            MovimientosDocumentos.push({
                                VolumenId : volsId.VolumenId,
                                IncidenteId: null,
                                TerceriaId: null,
                                FechaMovimiento : moment().format('YYYY-MM-DD HH:MM:SS'),
                                TiposMovimientos: {"TipoMovimientoId": 1},
                                UsuarioQuienPresta: {"IdUsuario" : usr},
                                UsuarioQuienRecibe: {"IdUsuario" : usr},
                                AreaQuePresta : {"AreaId" : areaArchivo},
                                AreaQueRecibe : {"AreaId" : areaArchivo},
                                SolicitudDocumentoId: solicitud.SolicitudDocumentoId,
                                Observaciones: "Movimiento de Documento en cancelación de prestamo con solicitud No. " + solicitud.SolicitudDocumentoId
                            });
                        
                    });
                    
                    $.each(solicitud.IncidentesEnSolicitud, function (indice, volsId){

                            MovimientosDocumentos.push({
                                VolumenId : null,
                                IncidenteId: volsId.IncidenteId,
                                TerceriaId: null,
                                FechaMovimiento : moment().format('YYYY-MM-DD HH:MM:SS'),
                                TiposMovimientos: {"TipoMovimientoId": 1},
                                UsuarioQuienPresta: {"IdUsuario" : usr},
                                UsuarioQuienRecibe: {"IdUsuario" : usr},
                                AreaQuePresta : {"AreaId" : areaArchivo},
                                AreaQueRecibe : {"AreaId" : areaArchivo},
                                SolicitudDocumentoId: solicitud.SolicitudDocumentoId,
                                Observaciones: "Movimiento de Documento en cancelación de prestamo con solicitud No. " + solicitud.SolicitudDocumentoId
                            });
                            
                    });
                    $.each(solicitud.TerceriasEnSolicitud, function (indice, volsId){

                            MovimientosDocumentos.push({
                                VolumenId : null,
                                IncidenteId: null,
                                TerceriaId: volsId.TerceriaId,
                                FechaMovimiento : moment().format('YYYY-MM-DD HH:MM:SS'),
                                TiposMovimientos: {"TipoMovimientoId": 1},
                                UsuarioQuienPresta: {"IdUsuario" : usr},
                                UsuarioQuienRecibe: {"IdUsuario" : usr},
                                AreaQuePresta : {"AreaId" : areaArchivo},
                                AreaQueRecibe : {"AreaId" : areaArchivo},
                                SolicitudDocumentoId: solicitud.SolicitudDocumentoId,
                                Observaciones: "Movimiento de Documento en cancelación de prestamo con solicitud No. " + solicitud.SolicitudDocumentoId
                            });
                            
                    });
                    

                });
            
            if(SolicitudesAutorizadas.length > 0)
            {
                bootbox.confirm({
                    title: "Mensaje del sistema",
                    message: "¿Desea cancelar la(s) solicitud(es)?",
                    buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta)=> {
                    if (respuesta) {
                                var peticion = {
                                    SolicitudesAutorizadas, MovimientosDocumentos, "Eliminar" : true
                                };
                                comun.SeEstaCargandoInformacion(true);
                                axios.post(api.conexion + api.ArchivoJudicial.CambiaEstadoSolicitud, peticion, comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                                ).then(respuesta => {
                                    if(respuesta.data.SiHayError)
                                    {
                                        console.log(respuesta);
                                        comun.SeEstaCargandoInformacion(false);
                                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                                    }
                                    else
                                    {
                                        $.each(SolicitudesAutorizadas, function(id, solicitud)
                                        {
                                            _this.CanceladasReporte.push(solicitud)
                                        })
                                        comun.mensajeDeAlerta("Se ha Cancelado la Solicitud", null, null);
                                        this.ObtenSolicitudes(false);
                                        if(this.Solicitudes.length==0)
                                        {
                                            this.GenerarPrint(this.CanceladasReporte, this.UsuarioArchivo);
                                        }
                                        this.Autorizadas =[];
                                        this.Canceladas=[];
                                    }
                                    comun.SeEstaCargandoInformacion(false);

                                }
                                ).catch(excepcion => {
                                    console.log(excepcion);
                                    comun.SeEstaCargandoInformacion(false);
                                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                                });
                        }
                    }
                });
            }
            else{
                comun.mensajeDeAlerta("Seleccione Solicitudes para Cancelación", null, null);
            }
        },
        EstatusModal(valor){
            this.Detalles = valor;
        },
        EstatusObservaciones(valor) {
            this.Arch_Observaciones = valor.Estatus;
            this.Solicitudes.find(id=>id.SolicitudDocumentoId==valor.Id).ObservacionesArchivo= valor.Texto;
        },
        GenerarPrint (Listado, usrArchivo){
            let NombreFirma = this.SecretarioAcuerdos;
            let PuestoFirma = this.PuestoFirma;
            var UsuariosFirmas =[];
            let _this= this;
            Listado.sort(this.sortAnioConsecutivo);
            
            //UsuariosFirmas.push({"Nombre": usrArchivo.Nombre, "ApPaterno": usrArchivo.ApellidoPaterno, "ApMaterno": usrArchivo.ApellidoMaterno, "Area": usrArchivo.AreaAsignado.Nombre});
            var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
            printWin.document.open();
            printWin.document.write('<html><head><title>Archivo Judicial</title>');
            printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
            printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet" type="text/css" media="print">');
            printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet" type="text/css" media="print">');
            printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet" type="text/css" media="print">');
            printWin.document.write('</head><body>');
            printWin.document.write('<div class="col-md-12">');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-3 align-self-center">');
            printWin.document.write('<img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/></div>');
            printWin.document.write('<div class="form-group col-6 text-center align-self-center">');
            printWin.document.write('<h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5></div>');
            printWin.document.write('<div class="form-group col-3"></div></div></div>');
            printWin.document.write('<div class="area"><div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h5 class="text-center">LISTADO DE SOLICITUDES AUTORIZADAS</h5></div>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 align-self-center" >');
            printWin.document.write('<div class="text-center">');
            printWin.document.write('<h6 class="text-center">ENTREGA DE DOCUMENTOS</h6>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 text-right">');
            printWin.document.write('<label>Aguascalientes, Ags., a  '+ moment().format('DD/MM/YYYY') + '</label>');
            printWin.document.write('</div></div>');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12 ">');
            printWin.document.write('<label>Area: '+ this.AreaEtiqueta +'</label>');
            printWin.document.write('</div></div></div>');
            printWin.document.write('<div class="area">');
            printWin.document.write('<div class="row">');
            printWin.document.write('<div class="form-group col-12" style="display: block; page-break-before: auto;">');
            printWin.document.write('<div class="table-reponsive">');
            printWin.document.write('<table class="table table-striped table-light table-bordered table-sm">');
            printWin.document.write('<thead><tr><th >No.</th><th >Documento</th><th >Consecutivo</th><th >Solicitado por:</th>');
            printWin.document.write('<th>Observaciones</th></tr></thead><tbody class="text-dark">');
            //ciclo inicio
            $.each(Listado, function(index, SolicitudesImpresion){

                var Detalle = SolicitudesImpresion.ObservacionesArchivo !=null ? SolicitudesImpresion.ObservacionesArchivo : "";
                if(Detalle!="")
                {
                    Detalle=Detalle + "<br/>";
                };
                printWin.document.write('<tr>');
                printWin.document.write('<td width="30">'+ SolicitudesImpresion.SolicitudDocumentoId +'</td>');
                printWin.document.write('<td width="200">'+ SolicitudesImpresion.InventarioDocumentos.TipoDocumento.Nombre +'</td>');
                printWin.document.write('<td width="50">'+ SolicitudesImpresion.InventarioDocumentos.Consecutivo +'/' + SolicitudesImpresion.InventarioDocumentos.Anio +'</td>');
                printWin.document.write('<td width="200">'+ SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre
                                              + ' ' + SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno
                                              + ' ' + SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno +'</td>');
                printWin.document.write('<td width="250">'+ Detalle +'</td>');
                //printWin.document.write('<td width="200">'+ _this.DesglosaContenido(SolicitudesImpresion) +'</td>');
                printWin.document.write('</tr>');
                var Existe = UsuariosFirmas.findIndex(datos => datos.Nombre == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre &&
                                                    datos.ApPaterno == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno &&
                                                    datos.ApMaterno == SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno);
                if(Existe == -1)
                    {
                        UsuariosFirmas.push({
                                "Nombre": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.Nombre,
                                "ApPaterno": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno,
                                "ApMaterno": SolicitudesImpresion.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno,
                                "Area": SolicitudesImpresion.Juzgado.AreaIdQueSolicita.Nombre
                                            });
                    }

            });
            //ciclo fin

            printWin.document.write('</tbody></table></div></div></div>');
            printWin.document.write('<div class="area" style="display: block; page-break-after: avoid;">');
            

                        
                        printWin.document.write('<br><br><br><br><br>');
                        printWin.document.write('<div class="row">');
                        printWin.document.write('   <div class="form-group col-5" style="border-top: 1px solid black";>');// style="border: 1px solid black";>');
                        printWin.document.write('       <div class="text-center">');
                        printWin.document.write('           <label><strong>'+ ( NombreFirma!=null ? NombreFirma : "") + '</strong></label>');
                        printWin.document.write('       </div>');
                        printWin.document.write('       <div class="text-center">');
                        printWin.document.write('           <label><strong>'+(PuestoFirma!=null ? PuestoFirma : "PRIMER SECRETARIO DE ACUERDOS") + '</strong></label>');
                        printWin.document.write('       </div>');
                        printWin.document.write('   </div>');
                        printWin.document.write('   <div class="form-group col-2" ></div>')
                        printWin.document.write('   <div class="form-group col-5" style="border-top: 1px solid black";>');// style="border: 1px solid black";>');
                        printWin.document.write('       <div class="text-center">');
                        printWin.document.write('           <label><strong>SELLO</strong></label>');
                        printWin.document.write('       </div>');
                        // printWin.document.write('       <div class="text-center">');
                        // printWin.document.write('           <label><strong>' + ( this.SecretarioAcuerdo!=null ? this.SecretarioAcuerdo.EstructuraOrganica.TipoDepartamentoArea.Area.Nombre.toUpperCase() : "") +'</label>');
                        // printWin.document.write('       </div>');
                        printWin.document.write('   </div>');

                        printWin.document.write('</div>');
           
            printWin.document.write('</div>');
            printWin.document.write('</div>');

            printWin.document.write('</body></html>');
            var css = '@page { size: Letter;  margin: 15mm 15mm 15mm 15mm; }',
            head = printWin.document.head || document.getElementsByTagName('head')[0],
            style = printWin.document.createElement('style');

            style.type = 'text/css';
            style.media = 'print';

            if (style.styleSheet) {
            style.styleSheet.cssText = css;
            } else {
            style.appendChild(printWin.document.createTextNode(css));
            }
            head.appendChild(style);
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        },
        ImprimirVales(datos){
            var ListadoVales = datos//this.Solicitudes;
            
            let _this =this;
            if(ListadoVales.length>0)
            {
                var TotalSolicitudes = ListadoVales.length;
                var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
                printWin.document.open();
                printWin.document.write('<html><head><title>Archivo Judicial</title>');
                printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
                printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet" type="text/css" media="print">');
                printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet" type="text/css" media="print">');
                printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet" type="text/css" media="print">');
                printWin.document.write('</head><body>');
                for (var i = 0; i < TotalSolicitudes; i++) {
                printWin.document.write('<div class="col-12 padding-div-low" style="display: block; page-break-before: always;">');
                //printWin.document.write('<div class="area">');
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-3 align-self-center">');
                printWin.document.write('       <img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/>');
                printWin.document.write('   </div>');
                printWin.document.write('   <div class="form-group col-6 text-center align-self-center">');
                printWin.document.write('           <h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5>');
                printWin.document.write('   </div>');
                printWin.document.write('   <div class="form-group col-3"></div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row" >');
                printWin.document.write('   <div class="form-group col-12 align-self-center">');
                printWin.document.write('       <div class="text-center">');
                printWin.document.write('           <h5 class="text-center">SOLICITUD DE DOCUMENTO</h5></div></div></div><br>');
                printWin.document.write('<div class="row">');

                printWin.document.write('   <div class="form-group col-12 text-right"><label>Aguascalientes, Ags., a  '+ moment().format('DD/MM/YYYY') + '</label></div>');
   
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('<div class="form-group col-12 text-center">');
                printWin.document.write('   <h5>Datos de la Solicitud</h5>');
                printWin.document.write('</div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-2"><label><strong>Solicitud # : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-4" ><label>'+ ListadoVales[i].SolicitudDocumentoId +'</label></div>');
                printWin.document.write('   <div class="form-group col-2"><label><strong>Fecha de Registro: </strong></label></div>');
                printWin.document.write('   <div class="form-group col-4" ><label>'+ moment(ListadoVales[i].FechaRegistro).format('DD/MM/YYYY')  +'</label></div>');

                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-2"><label><strong>Observaciones : </strong></label></div>');
                var ArchivoObservaciones= "";
                if(ListadoVales[i].ObservacionesArchivo!=null)
                {
                    ArchivoObservaciones = ListadoVales[i].ObservacionesArchivo
                }
                printWin.document.write('   <div class="form-group col-10" ><label>'+ ArchivoObservaciones +'</label></div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-12 text-center">');
                printWin.document.write('       <h5>Datos del Solicitante</h5>');
                printWin.document.write('   </div>');
                printWin.document.write('</div>');
                
                printWin.document.write('<div class="row">');

                printWin.document.write('   <div class="form-group col-2" ><label><strong>Nombre : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-10" ><label>'+ ListadoVales[i].Juzgado.UsuarioIdQuienSolicita.Nombre + " "  + ListadoVales[i].Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno + " " + ListadoVales[i].Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno +'</label></div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');

                printWin.document.write('   <div class="form-group col-2" ><label><strong>Area : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-10" ><label>'+ ListadoVales[i].Juzgado.AreaIdQueSolicita.Nombre +'</label></div>');
                printWin.document.write('</div>');
            
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-12 text-center">');
                printWin.document.write('       <h5>Datos del Documento</h5>');
                printWin.document.write('   </div>');
                printWin.document.write('</div>');

                printWin.document.write('<div class="row">');

                printWin.document.write('   <div class="form-group col-2"><label><strong>Tipo : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-4" ><label>'+ ListadoVales[i].InventarioDocumentos.TipoDocumento.Nombre +'</label></div>');
                printWin.document.write('   <div class="form-group col-2"><label><strong>Consecutivo : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-4" ><label>'+ ListadoVales[i].InventarioDocumentos.Consecutivo + '/'+ ListadoVales[i].InventarioDocumentos.Anio +'</label></div>');

                printWin.document.write('</div>');
                printWin.document.write('<br>');
                
                printWin.document.write('<div style="page-break-inside: avoid; page-break-after: auto" >');//prueba
                printWin.document.write('<div class="row">');
                printWin.document.write('       <div class="form-group col-12" style="border-style: dotted; border-width: 4px;">');
                printWin.document.write('           <label><strong>PARA USO EXCLUSIVO DEL ARCHIVO</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label><strong>Ubicación:</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label><strong>Numero de Hojas:</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label><strong>Entregó:</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label><strong>Anexos:</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label><strong>Fecha de Devolución:</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label><strong>Recibió:</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('</div>');
                //printWin.document.write('</div>'); // prueba
                

                printWin.document.write('</div></div>');
            }
            printWin.document.write('</body></html>');

            var css = '@page { size: Letter;  margin: 15mm 15mm 15mm 15mm; }',
            head = printWin.document.head || document.getElementsByTagName('head')[0],
            style = printWin.document.createElement('style');

            style.type = 'text/css';
            style.media = 'print';

            if (style.styleSheet) {
            style.styleSheet.cssText = css;
            } else {
            style.appendChild(printWin.document.createTextNode(css));
            }
            head.appendChild(style);
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
            }
            else
            {
                comun.mensajeDeAlerta("Seleccione una o varias Solicitudes para Autorizar", null, null);
            }
        },
        ValidaDatos(){
            if(this.BusquedaForm.parametros_Area.areaId == -1)
            {
                comun.mensajeDeAlerta("Seleccion una área para consulta", null, null);
                return false;
            }
            return true;
        },
        AgregaComentario(Lista){
            this.idModal = Lista.SolicitudDocumentoId;
            this.ObsModal = Lista.ObservacionesArchivo;
            this.Arch_Observaciones = true;
        },
        SeleccionSolicitudes(){
            let solicitudesSeleccionadas = [];
            this.Autorizadas.forEach((element) =>{
                let agregaSolicitud = this.Solicitudes.find(sol=>sol.SolicitudDocumentoId == element);
                agregaSolicitud.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId = 2;
                solicitudesSeleccionadas.push(agregaSolicitud);
            });
            return solicitudesSeleccionadas;
        },
        SeleccionCanceladas(){
            let solicitudesCanceladas = [];
            this.Canceladas.forEach((element) =>{
                let agregaSolicitud = this.Solicitudes.find(sol=>sol.SolicitudDocumentoId == element);
                agregaSolicitud.TipoEstatusSolicitud.TipoEstatusSolicitudDocumentoId = 5;
                solicitudesCanceladas.push(agregaSolicitud);
            });
            return solicitudesCanceladas;
        },
        DesglosaContenido: function (datos){
            
            let Contenido ="";
            if(datos.VolumenesEnSolicitud.length>0)
            {   
                $.each(datos.VolumenesEnSolicitud, function(index, Listado)
                { 
                    Contenido = Contenido + "<b >VOLUMEN NO. :</b>" + Listado.Volumenes.NumVolumen + "<br/>"   
                });
            };
            if(datos.IncidentesEnSolicitud.length>0)
            {
                $.each(datos.IncidentesEnSolicitud, function(index, enVolumen)
                {
                    Contenido = Contenido + "<b>INCIDENTE NO :</b>" + enVolumen.Incidentes.NumeroIncidente + "<br/>";
                });
            }
            if(datos.TerceriasEnSolicitud.length>0)
            {
                var lineaTexto ="";
                
                
                $.each(datos.TerceriasEnSolicitud, function(index, enVolumen)
                {
                    
                        Contenido = Contenido + "<b >TERCERIA NO. :</b>"+ enVolumen.Tercerias.NumeroTerceria  + "<br/>";
                    
                })
            }
            return Contenido;
        },
        SelectAll(evento){
            this.Autorizadas= [];
            if(this.SeleccionarTodos != false)
            {
                for (let i in this.Solicitudes)
                {
                    this.Autorizadas.push(this.Solicitudes[i].SolicitudDocumentoId)
                }
            };
        },
        DesglosaParaImpresion: function (datos) {
            
            let Contenido ="";
            Contenido = Contenido + "<b>TOMO NO. " + datos.NumVolumen + "</b><br/>" ;                       
            return Contenido;
        },
        ObtenerTodosVales(){
            var peticion = {
                "AreaId" : 0
            };
            
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + this.SolicitudApi, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
            .then( respuesta => {
                if(respuesta.data.SiHayError)
                {
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {
                    var listaTodos = respuesta.data.GetSolicitudes;
                    var urgentes = listaTodos.filter(a=>a.ObservacionesJuzgado=='Urgente');
                    
                    this.TodosParaVales = listaTodos.sort((a,b)=>(a.InventarioDocumentos.CodigoBarras>b.InventarioDocumentos.CodigoBarras ? 1:-1));
                    this.UsuarioArchivo =  respuesta.data.UsuarioArchivo;
                    if(this.TodosParaVales.length>0)
                    {
                        console.log(this.FechaDeAcceso)
                        bootbox.confirm({
                        title: "Mensaje del sistema",
                        message: "Desea imprimir vales de todas la solicitudes por verificar?<br/>",
                        buttons: {
                        cancel: {
                            label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                        },
                        confirm: {
                            label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir'
                        }
                            },
                            callback: (respuestaSalir) => {
                                if (respuestaSalir) {
                                   this.ImprimirVales(this.TodosParaVales);
                                }
                            }
                                
                            });
                    }
                }
                comun.SeEstaCargandoInformacion(false);

                })
                .catch(excepcion => {
                console.log(excepcion);
                comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                comun.SeEstaCargandoInformacion(false);

            })
        },
        ObtenSolicitudesPosteriores()
        {
            
        },
        sortAnioConsecutivo: function (a,b)
        {
            if(a.InventarioDocumentos.TipoDocumento.TipoDocumentoId < b.InventarioDocumentos.TipoDocumento.TipoDocumentoId) return -1
            if(a.InventarioDocumentos.TipoDocumento.TipoDocumentoId > b.InventarioDocumentos.TipoDocumento.TipoDocumentoId) return 1
            if(a.InventarioDocumentos.Anio < b.InventarioDocumentos.Anio) return -1
            if(a.InventarioDocumentos.Anio > b.InventarioDocumentos.Anio) return 1
            if(a.InventarioDocumentos.Consecutivo < b.InventarioDocumentos.Consecutivo) return -1
            if(a.InventarioDocumentos.Consecutivo > b.InventarioDocumentos.Consecutivo) return 1
            return 0
        },
        ImprimirValeSeleccionado(dato){
            
                var printWin = window.open('', '_blank', 'width=600,height=720,location=no,left=100px');
                printWin.document.open();
                printWin.document.write('<html><head><title>Archivo Judicial</title>');
                printWin.document.write('<link rel="" href="/src/assets/favicon.ico">');
                printWin.document.write('<link href="/static/css/bootstrap.min.css" rel="stylesheet" type="text/css" media="print">');
                printWin.document.write('<link href="/static/css/all.min.css" rel="stylesheet" type="text/css" media="print">');
                printWin.document.write('<link href="/static/css/bootstrap-table.min.css" rel="stylesheet" type="text/css" media="print">');
                printWin.document.write('</head><body>');
                
                printWin.document.write('<div class="col-12 padding-div-low" style="display: block; page-break-before: always;">');
                //printWin.document.write('<div class="area">');
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-3 align-self-center">');
                printWin.document.write('       <img src="' + LogoPJE +'" width="185" height="150" alt="Logo de Poder Judicial del Estado de Aguascalientes"/>');
                printWin.document.write('   </div>');
                printWin.document.write('   <div class="form-group col-6 text-center align-self-center">');
                printWin.document.write('           <h5 class="text-center">DIRECCIÓN DEL ARCHIVO JUDICIAL</h5>');
                printWin.document.write('   </div>');
                printWin.document.write('   <div class="form-group col-3"></div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row" >');
                printWin.document.write('   <div class="form-group col-12 align-self-center">');
                printWin.document.write('       <div class="text-center">');
                printWin.document.write('           <h5 class="text-center">SOLICITUD DE DOCUMENTO</h5></div></div></div><br>');
                printWin.document.write('<div class="row">');

                printWin.document.write('   <div class="form-group col-12 text-right"><label>Aguascalientes, Ags., a  '+ moment().format('DD/MM/YYYY') + '</label></div>');
   
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('<div class="form-group col-12 text-center">');
                printWin.document.write('   <h5>Datos de la Solicitud</h5>');
                printWin.document.write('</div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-2"><label><strong>Solicitud # : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-4" ><label>'+ dato.SolicitudDocumentoId +'</label></div>');
                printWin.document.write('   <div class="form-group col-2"><label><strong>Fecha de Registro: </strong></label></div>');
                printWin.document.write('   <div class="form-group col-4" ><label>'+ moment(dato.FechaRegistro).format('DD/MM/YYYY')  +'</label></div>');

                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-2"><label><strong>Observaciones : </strong></label></div>');
                var ArchivoObservaciones= "";
                if(dato.ObservacionesArchivo!=null)
                {
                    ArchivoObservaciones = dato.ObservacionesArchivo
                }
                printWin.document.write('   <div class="form-group col-10" ><label>'+ ArchivoObservaciones +'</label></div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-12 text-center">');
                printWin.document.write('       <h5>Datos del Solicitante</h5>');
                printWin.document.write('   </div>');
                printWin.document.write('</div>');
                
                printWin.document.write('<div class="row">');

                printWin.document.write('   <div class="form-group col-2" ><label><strong>Nombre : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-10" ><label>'+ dato.Juzgado.UsuarioIdQuienSolicita.Nombre + " "  + dato.Juzgado.UsuarioIdQuienSolicita.ApellidoPaterno + " " + dato.Juzgado.UsuarioIdQuienSolicita.ApellidoMaterno +'</label></div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');

                printWin.document.write('   <div class="form-group col-2" ><label><strong>Area : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-10" ><label>'+ dato.Juzgado.AreaIdQueSolicita.Nombre +'</label></div>');
                printWin.document.write('</div>');
            
                printWin.document.write('<div class="row">');
                printWin.document.write('   <div class="form-group col-12 text-center">');
                printWin.document.write('       <h5>Datos del Documento</h5>');
                printWin.document.write('   </div>');
                printWin.document.write('</div>');

                printWin.document.write('<div class="row">');

                printWin.document.write('   <div class="form-group col-2"><label><strong>Tipo : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-4" ><label>'+ dato.InventarioDocumentos.TipoDocumento.Nombre +'</label></div>');
                printWin.document.write('   <div class="form-group col-2"><label><strong>Consecutivo : </strong></label></div>');
                printWin.document.write('   <div class="form-group col-4" ><label>'+ dato.InventarioDocumentos.Consecutivo + '/'+ dato.InventarioDocumentos.Anio +'</label></div>');

                printWin.document.write('</div>');
                printWin.document.write('<br>');
                
                printWin.document.write('<div style="page-break-inside: avoid; page-break-after: auto" >');//prueba
                printWin.document.write('<div class="row">');
                printWin.document.write('       <div class="form-group col-12" style="border-style: dotted; border-width: 4px;">');
                printWin.document.write('           <label><strong>PARA USO EXCLUSIVO DEL ARCHIVO</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label><strong>Ubicación:</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label><strong>Numero de Hojas:</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label><strong>Entregó:</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label><strong>Anexos:</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('</div>');
                printWin.document.write('<div class="row">');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label><strong>Fecha de Devolución:</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-2">');
                printWin.document.write('           <label><strong>Recibió:</strong></label>');
                printWin.document.write('       </div>');
                printWin.document.write('       <div class="form-group col-4" style="border-bottom: 1px solid black; ">');
                printWin.document.write('       </div>');
                printWin.document.write('</div>');
                //printWin.document.write('</div>'); // prueba
                

                printWin.document.write('</div></div>');
            
            printWin.document.write('</body></html>');

            var css = '@page { size: Letter;  margin: 15mm 15mm 15mm 15mm; }',
            head = printWin.document.head || document.getElementsByTagName('head')[0],
            style = printWin.document.createElement('style');

            style.type = 'text/css';
            style.media = 'print';

            if (style.styleSheet) {
            style.styleSheet.cssText = css;
            } else {
            style.appendChild(printWin.document.createTextNode(css));
            }
            head.appendChild(style);
            setTimeout(function(){ printWin.print(); }, 1000)
            printWin.document.close();
            printWin.focus();
        }
    },
    mounted(){
        this.ObtenerTodosVales();
        this.FechaDeAcceso = moment().format('YYYY-MM-DD HH:MM:SS');
    }
}
</script>

<style scoped>
    #cuerpoModalDetalles{
        overflow-y:auto;
        max-height: 500px;
    }
    input[type="text"]:read-only {
        background: #7e7f74;
    }
    input[type="text"]:read-only:focus {
      color: #fff;
    }
    textarea[type="text"]:read-only {
    background: #7e7f74;
    }    
    textarea[type="text"]:read-only:focus {
      color: #fff;
    }
    .thead-custom {
        background-color: #004746;
        color: white;
    }
    .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
  </style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/SolicitudesVerifica.vue